module.exports = __webpack_public_path__ + "img/stop_record_icon.8d7d445a.svg";